import React from 'react';
import {CardContainer} from 'components/common/uiKit';

import LiftImage from 'assets/images/courses/lift.JPG';

class Cart extends React.Component {

    render() {
        return (
            <CardContainer>
                <div className="d-flex pb-2">
                    <div className="ml-auto">
                        <img src={LiftImage} className="rounded-m shadow-xl" width="80"/>
                    </div>
                    <div className="mr-auto w-100 pr-3">
                        <h2 className="font-21 font-600 opacity-80 pb-2">
                            فیبرز
                        </h2>
                        <h4 className="font-14 font-700 pt-2 ">
                            1000
                            <sup className="font-11 opacity-50" style={{padding: '0 5px'}}>تومان</sup>
                        </h4>
                    </div>
                </div>
            </CardContainer>
        );
    }
}

export default Cart;